import React from "react"
import useReportingAndAnalyticsApi from "../../useReportingAndAnalyticsApi";
import useAppStoreContext from "../../../../../shared/context/app-store/app-store.context";
import useLoader from "../../../../../shared/components/loading-dialog/useLoader.hook";
import LoadingDialogComponent from "../../../../../shared/components/loading-dialog/loading-dialog.component";
import IReportDataBody from "../../../../../shared/contracts/IReportDataBody";


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export function useGetReportDataApi() {

    const { getReportData } = useReportingAndAnalyticsApi();

    const {
        selReportCode, selReportDetails, setSelReportData,
        currentFilters, currentSelectedColumns,
    } = useAppStoreContext();


    const getPayload = (): IReportDataBody => {
        let reportBody: IReportDataBody = {
            filterCriterias: currentFilters,
            columnSelections: currentSelectedColumns,
            pivotSelections: selReportDetails?.pivotSelections || [],
            fetchDataWithExistingMetadata: false
        };
        return reportBody;
    }

    const reportDataLoader = useLoader({
        loaderName: "Report Data",
        loadAsync: () =>
            getReportData(
                getPayload(),
                {
                    doIf: () => !!(selReportCode) && reportDataLoader.isNotLoading,
                    doBefore: () => {
                        setSelReportData([]);
                        reportDataLoader.SET_LOADING("Fetching Report Data...");
                    },
                    onFulfilled: (data) => {
                        // const normalizedData = normalizeKeys(data); // Normalize the data first
                        setSelReportData(data);
                        reportDataLoader.SET_SUCCESS("Fetch Success.!");
                    },
                    onException: reportDataLoader.SET_EXCEPTION,
                }
            ),
    });


    const ReportDataProgressIndicator = () => {
        return <LoadingDialogComponent loaderHook={reportDataLoader} />
    }

    return {
        reportDataLoader,
        ReportDataProgressIndicator
    }
}